import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "exception-limit-settings__title-block" }
const _hoisted_2 = { class: "exception-limit-settings__logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "exception-limit-settings__name-block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Internal name", -1 /* HOISTED */)
const _hoisted_6 = { class: "exception-limit-settings__name-block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Public name", -1 /* HOISTED */)
const _hoisted_8 = { class: "exception-limit-settings__limit-list-item-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_LimitException = _resolveComponent("LimitException")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.isExceptionLimitSettingsSidebarVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isExceptionLimitSettingsSidebarVisible) = $event)),
    title: "Exception limits",
    "append-to-body": "",
    size: "700",
    class: "exception-limit-settings",
    onClose: _ctx.closeExceptionLimitSettings
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.currentGeoPaymentMethod.filePath,
              class: "exception-limit-settings__image",
              alt: "payment system logo"
            }, null, 8 /* PROPS */, _hoisted_3)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_tag, { type: "info" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentGeoPaymentMethod.paymentSystem), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("p", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_tag, { type: "info" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentGeoPaymentMethod.publicName), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extendedPaymentMethodExceptionLimitList, (exceptionLimit) => {
          return (_openBlock(), _createBlock(_component_el_card, {
            key: exceptionLimit.currency,
            shadow: "hover",
            class: "exception-limit-settings__card-item"
          }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(exceptionLimit.currency ?? 'Currency not selected') + " ", 1 /* TEXT */),
              _createVNode(_component_el_tag, {
                type: "info",
                class: "exception-limit-settings__card-tag"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(exceptionLimit.min) + " - " + _toDisplayString(exceptionLimit.max), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exceptionLimit.limitList, (exceptionLimitItem) => {
                    return (_openBlock(), _createBlock(_component_LimitException, {
                      key: exceptionLimitItem.id,
                      "exception-limit-item": exceptionLimitItem,
                      class: "exception-limit-settings__limit-list-item",
                      onUpdateExceptionLimitItem: _ctx.updateExceptionLimitItem
                    }, null, 8 /* PROPS */, ["exception-limit-item", "onUpdateExceptionLimitItem"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (_ctx.isAddLimitExceptionButtonVisible)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        disabled: !_ctx.isAddExceptionLimitItemEnable(exceptionLimit.currency),
                        class: "exception-limit-settings__add-exception",
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (_ctx.addExceptionLimitItem(exceptionLimit.currency))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Add exceptions ")
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])), [
        [_directive_loading, _ctx.isExceptionLimitListLoading]
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}